import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import ShowcaseGrid from '../components/Home/ShowcaseGrid';
import PublicationsSection from '../components/Home/PublicationsSection';
import NewsSection from '../components/Home/NewsSection';
import EventsSection from '../components/Home/EventsSection';
import MezunYorumlari from '../components/Home/MezunYorumlari';
import GalleryPreviewSection from '../components/Home/GalleryPreviewSection';
import InstagramSection from '../components/Home/InstagramSection';
const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ShowcaseGrid />
      <PublicationsSection />
      <NewsSection />
      <EventsSection />
      <MezunYorumlari />
      <GalleryPreviewSection />
      <InstagramSection />
    </div>
  );
};

export default Home; 